<template>
    <div>
        <app-tabela
            :itens="contrato.avaliacoes"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
            :mostrarFiltro="false"
        >
            <template slot="respostas" slot-scope="data">
                <app-tabela
                    :itens="data.respostas"
                    :campos="camposRespostas"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                    :mostrarFiltro="false"
                >
                    <template slot="percentual" slot-scope="data">
                        <span>{{ data.percentual | currency2 }}</span>
                    </template>
                </app-tabela>
            </template>
            <template slot="grafico" slot-scope="data">
                <div class="chart-wrapper">
                    <grafico
                        v-if="data.perguntaId"
                        :id="`${data.perguntaId}`"
                        :titulos="obterTitulos(data.respostas)"
                        :valores="obterValores(data.respostas)"
                    ></grafico>
                </div>
            </template>
        </app-tabela>
        <ocorrencias :contrato="contrato"></ocorrencias>
    </div>
</template>

<script>
import Grafico from './Grafico'
import Ocorrencias from '../ocorrencias/OcorrenciasGerais'

export default {
    props: {
        contrato: {
            type: Object
        }
    },

    components: {
        Grafico,
        Ocorrencias
    },

    data() {
        return {
            campos: [
                {
                    key: 'pergunta',
                    label: 'Pergunta',
                    sortable: true
                },
                {
                    key: 'respostas',
                    label: 'Respostas'
                },
                {
                    key: 'grafico',
                    label: ''
                }
            ],
            camposRespostas: [
                {
                    key: 'resposta',
                    label: 'Resposta',
                    sortable: true
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade'
                },
                {
                    key: 'percentual',
                    label: 'Percentual'
                }
            ],
            itensPorPagina: 0
        }
    },

    methods: {
        obterTitulos(respostas) {
            return respostas.map((p) => {
                return p.resposta
            })
        },

        obterValores(respostas) {
            return respostas.map((p) => {
                return p.quantidade
            })
        }
    }
}
</script>